module.exports = __webpack_public_path__ + "img/icomoon.5670ea8c.svg";